class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close(),
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this),
    );
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer");
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true },
    );

    document.body.classList.add("overflow-hidden");
    document.dispatchEvent(cartChange);
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id,
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open"),
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.productId = parsedState.id;

    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      //console.log("parsedState", parsedState);
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector,
      );
    });

    function debounce(func, wait) {
      let timeout;
      return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
      };
    }

    // Debounced version of addMessageToCart
    const debouncedAddMessageToCart = debounce(addMessageToCart, 500);
    const giftMessageContainers = document.querySelectorAll(".gift-message");

    giftMessageContainers.forEach((giftMessageContainer) => {
      const giftMessageTextarea =
        giftMessageContainer.querySelector("textarea");
      const giftMessageToggle = document.getElementById("gift-message--toggle");

      // Save message across pages
      // const savedMessage = localStorage.getItem("giftMessage");
      // if (savedMessage) {
      //   giftMessageTextarea.value = savedMessage;
      //   updateCharacterCount(giftMessageTextarea, giftMessageContainer);
      //   if (giftMessageToggle) {
      //     giftMessageToggle.checked = true;
      //   }
      //   addMessageToCart(giftMessageTextarea);
      // }

      // When textarea changes, update gift message value
      giftMessageTextarea.addEventListener("input", () => {
        // let characterCount = giftMessageTextarea.value.length;
        // let current = giftMessageContainer.querySelector(
        //   ".gift-message--current",
        // );
        // current.innerText = characterCount;

        // Save the current value to local storage
        // localStorage.setItem("giftMessage", giftMessageTextarea.value);
        // console.log("saved to local storage", giftMessageTextarea.value);

        debouncedAddMessageToCart(giftMessageTextarea);
      });
    });

    // Add event listener to the submit button
    const checkoutButton = document.querySelector(".cart__checkout-button");
    if (checkoutButton) {
      checkoutButton.addEventListener("click", () => {
        giftMessageContainers.forEach((giftMessageContainer) => {
          const giftMessageTextarea =
            giftMessageContainer.querySelector("textarea");
          addMessageToCart(giftMessageTextarea);
        });
      });
    }

    function addMessageToCart(textarea) {
      var formData = new FormData();
      formData.append("attributes[Gift Message]", textarea.value);
      formData.append("note", textarea.value);
      // Update cart attributes
      fetch(window.Shopify.routes.root + "cart/update.js", {
        method: "POST",
        body: formData,
      })
        .then((response) => response.json())
        .catch((error) => {
          console.error("Error updating cart:", error);
        });
    }

    // function updateCharacterCount(textarea, container) {
    //   let characterCount = textarea.value.length;
    //   let current = container.querySelector(".gift-message--current");
    //   current.innerText = characterCount;
    // }

    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this),
      );
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    // console.log("html:", html, "selector:", selector);
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);
